:root ._dsp-inline{display:inline;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._ww-break-word{word-wrap:break-word;}
:root ._ws-pre-wrap{white-space:pre-wrap;}
:root ._mt-0px{margin-top:0px;}
:root ._mr-0px{margin-right:0px;}
:root ._mb-0px{margin-bottom:0px;}
:root ._ml-0px{margin-left:0px;}
:root ._col-muted{color:var(--muted);}
:root ._grow-1{flex-grow:1;}
:root ._shrink-1{flex-shrink:1;}
:root ._fb-auto{flex-basis:auto;}
:root ._ff-f-family{font-family:var(--f-family);}
@media (hover) {:root:root  ._col-0hover-color:hover{color:var(--color) !important;}}